import { createEnum } from 'utils/jsUtils'

export const StatusType = createEnum([
  'PENDING',
  'RESCHEDULE_PENDING',
  'RESCHEDULED',
  'CONFIRMED',
  'DISABLED'
])
